module.exports = __webpack_public_path__ + "d98d817ba5aa7058dd9d40124c4ae4bd.svg";